if (!customElements.get('stock-availability')) {
  class StockAvailability extends HTMLElement {
    connectedCallback() {
      if (this.dataset.stockAvailReady === 'true') return;
      this.dataset.stockAvailReady = 'true';

      this.labelEl = this.querySelector('[data-stock-label]');
      this.variantInventory = this.getVariantInventory();

      const variantPicker = this.closest('.product')?.querySelector('variant-picker');
      if (variantPicker) {
        variantPicker.addEventListener('on:variant:change', this.handleVariantChange.bind(this));
      }

      this.updateFromQuantity(
        Number.parseInt(this.dataset.inventoryQuantity, 10),
        this.dataset.inventoryManagement,
        this.dataset.inventoryPolicy
      );
    }

    getVariantInventory() {
      const dataEl = this.querySelector('[type="application/json"]');
      if (!dataEl) return [];
      try {
        return JSON.parse(dataEl.textContent);
      } catch {
        return [];
      }
    }

    handleVariantChange(evt) {
      const variant = evt.detail?.variant;
      if (!variant) {
        this.hide();
        return;
      }

      const inventory = this.variantInventory.find((entry) => entry.id === variant.id);
      if (!inventory) {
        this.hide();
        return;
      }

      this.updateFromQuantity(
        inventory.inventory_quantity,
        inventory.inventory_management,
        inventory.inventory_policy
      );
    }

    updateFromQuantity(quantity, inventoryManagement, inventoryPolicy) {
      const qty = Number.isFinite(quantity) ? Math.max(0, quantity) : 0;
      const tracked = Boolean(inventoryManagement);
      const continuesSelling = inventoryPolicy === 'continue';

      let level;
      let label;
      let fillPct;

      if (!tracked || continuesSelling) {
        level = 'in';
        label = 'In stock';
        fillPct = 100;
      } else if (qty <= 0) {
        this.hide();
        return;
      } else if (qty > 10) {
        level = 'in';
        label = 'In stock';
        fillPct = 100;
      } else if (qty >= 3) {
        level = 'mid';
        label = `Only ${qty} left`;
        fillPct = (qty / 10) * 100;
      } else {
        level = 'low';
        label = `Only ${qty} left`;
        fillPct = (qty / 10) * 100;
      }

      this.dataset.stockLevel = level;
      this.style.setProperty('--stock-avail-fill', `${fillPct}%`);
      if (this.labelEl) this.labelEl.textContent = label;
      this.hidden = false;
    }

    hide() {
      this.hidden = true;
      this.removeAttribute('data-stock-level');
    }
  }

  customElements.define('stock-availability', StockAvailability);
}
